export default {
  teamArchived: 'team_is_archived',
  goalArchived: 'goal_is_archived',
  maxInitiativeCountLimitReached: 'max_initiative_count_limit_reached',
  maxGoalCountLimitReached: 'max_goal_count_limit_reached'
}
